import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop component
 * 
 * This component scrolls the window to the top whenever the route changes.
 * It uses the useLocation hook from react-router-dom to detect route changes.
 */
const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top when the pathname changes
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth' // For a smooth scrolling experience
    });
  }, [pathname]);

  // This component doesn't render anything
  return null;
};

export default ScrollToTop;
